import React, { useState, useEffect } from "react";
import clock from "../assets/clock.png"; // Cashback icon
import img1 from "../assets/img1.png";
import img2 from "../assets/img2.png";
import img3 from "../assets/img3.png";
import xbLogo from "../assets/xblogo.png";
import xbEnergy from "../assets/xblogo.png";
import giftemoji from "../assets/giftemoji.png";
import giftXB from "../assets/gift-xb.png";
import receXB from "../assets/Rectangle 22154 (2).png";
import coinIcon from "../assets/he 1.png";
import downArrow from "../assets/downArrow.png"; // Replace with the actual path to your image
import CoinOption from "./CoinOption";
import EnergyTime from "../assets/Vector-1.png";
import Carrot from "../assets/Vector 2.png";
import Carrot2 from "../assets/Vector-7.png";




import Navbar from "./Navbar";
import XboxCheckout from "./XboxCheckout";
import Login from "./Login"; // Import Login component
import GuestPop from "./GuestPop"; // Import Login component
import { useNavigate } from "react-router-dom";

import api from "../utils/api";
import { usePricing } from "../context/PricingContext";
import { useAuth } from "../context/AuthContext"; // Import AuthContext



const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    PKR: "₨",
    INR: "₹",
    CAD: "C$",
    SAR: "SAR", // Added symbol for SAR (Saudi Riyal)
    AUD: "A",
  };

  return symbols[currency] || currency; // Fallback to showing the currency code if symbol not found
};

const XboxCoins = () => {
  const navigate = useNavigate();
  const [showHigherTiers, setShowHigherTiers] = useState(false);
  const [selectedBonus, setSelectedBonus] = useState(0); // Add this with your other state declarations
  const [userId, setUserId] = useState(null);
  const [isNewCustomer, setIsNewCustomer] = useState(null); // null = loading, true/false = loaded
  const { currency, prices } = usePricing(); // Use global pricing context
  const { token } = useAuth(); // Use Auth context
  const currencySymbol = getCurrencySymbol(currency); // Get the symbol for the current currency
  const [quantity, setQuantity] = useState(100); // Quantity in thousands
  const [cashback, setCashback] = useState(0); // Cashback amount
  const [showTooltip, setShowTooltip] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // State for login popup
  const [amount, setAmount] = useState(0);
  const [cashbackRate, setCashbackRate] = useState(0); // Temporary variable for cashback rate
  const [gatewayFees, setGatewayFees] = useState(0.03); // Set to 5%
  const [guestCheckout, setGuestCheckout] = useState(false); // State to handle guest checkout
  const [showGuestPop, setShowGuestPop] = useState(false)
  const [ManualInputMode, setManualInputMode] = useState(true);
  const [selectedOption, setSelectedOption] = useState(0); // Default to first option
  const [showHigherTiersPC, setShowHigherTiersPC] = useState(true);



  const sliderSteps = [
    { value: 100, label: "100K" },
    { value: 1500, label: "1.5M" },
    { value: 3000, label: "3M" },
    { value: 4500, label: "4.5M" },
    { value: 6000, label: "6M" },
    { value: 7500, label: "7.5M" },
    { value: 9000, label: "9M" },
    { value: 10000, label: "10M" },

  ];

  useEffect(() => {
    const fetchUserAndCheckOrders = async () => {
      // For guests, show bonus by default
      if (!token) {
        setIsNewCustomer(true);
        return;
      }

      try {
        // Fetch user ID first
        const userResponse = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const userId = userResponse.data?._id;
        if (!userId) {
          setIsNewCustomer(false);
          return;
        }

        setUserId(userId);

        // Then check order count
        const orderResponse = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}/orders/count?userId=${userId}`
        );

        setIsNewCustomer(orderResponse.data?.count === 0);
      } catch (error) {
        console.error("Error checking customer status:", error);
        setIsNewCustomer(false);
      }
    };

    fetchUserAndCheckOrders();
  }, [token]);

  const [glowIntensity, setGlowIntensity] = useState(0.4)

  // Subtle pulsing effect for the inner glow
  useEffect(() => {
    const interval = setInterval(() => {
      setGlowIntensity((prev) => {
        const newValue = prev + (Math.random() * 0.1 - 0.05)
        return Math.max(0.3, Math.min(0.6, newValue))
      })
    }, 500)

    return () => clearInterval(interval)
  }, [])

  const calculatePosition = (value) => {
    const min = 100;
    const max = 10000;
    return ((value - min) / (max - min)) * 99;
  };
  const isValueNearStep = (currentValue, stepValue) => {
    const threshold = (stepValue >= 1000) ? 125 : 25;
    return Math.abs(currentValue - stepValue) <= threshold;
  };
  const toggleGuestPopup = () => {
    setShowGuestPop(!showGuestPop);
  };

  const handlePaymentIssue = () => {
    navigate("/payment-issue"); // Adjust the route to match your application's setup
  }


  // Fetch cashback rate
  useEffect(() => {
    const fetchCashback = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/cashback`);
        if (response.data?.cashback?.value) {
          setCashbackRate(response.data.cashback.value);
        } else {
          console.error("Cashback value not found in response");
        }
      } catch (error) {
        console.error("Error fetching cashback:", error);
      }
    };

    fetchCashback();
  }, []);

  // Fetch XB price
  useEffect(() => {
    if (prices && prices.XB > 0) {
      const calculatedAmount = (prices.XB * quantity) / 100;
      setAmount(calculatedAmount);
      setCashback(calculatedAmount * cashbackRate);
    }
  }, [prices, quantity, cashbackRate]);

  // Handle quantity change
  // Define all coin options with bonuses at the component level
  const coinOptions = {
    firstRow: [
      { value: 100, bonus: 0 },
      { value: 250, bonus: 0 },
      { value: 500, bonus: 25 },  // 500k=25k
      { value: 600, bonus: 30 }   // 600k=30k
    ],
    secondRow: [
      { value: 800, bonus: 40 },   // 800k=40k
      { value: 1000, bonus: 50 },  // 1000k=50k
      { value: 1500, bonus: 85 },  // 1500k=85k
      { value: 2000, bonus: 120 }  // 2000k=120k
    ],
    thirdRow: [
      { value: 2500, bonus: 160 },  // 2500k=160k
      { value: 3000, bonus: 210 },  // 3000k=210k
      { value: 3500, bonus: 270 },  // 3500k=270k
      { value: 4000, bonus: 330 }   // 4000k=330k
    ],
    fourthRow: [
      { value: 4500, bonus: 380 },  // 4500k=380k
      { value: 5000, bonus: 450 },  // 5000k=450k
      { value: 6000, bonus: 550 },  // 6000k=550k
      { value: 7000, bonus: 700 }   // 7000k=700k
    ],
    fifthRow: [
      { value: 8000, bonus: 820 },   // 8000k=820k
      { value: 10000, bonus: 1040 },  // 10000k=1040k
      { value: 12000, bonus: 1280 }, // 12000k=1280k
      { value: 15000, bonus: 1600 }   // 15000k=1600k
    ],
    sixthRow: [
      { value: 20000, bonus: 2300 }, // 20000k=2300k
      { value: 25000, bonus: 3000 }, // 25000k=3000k
      { value: 27000, bonus: 3250 }, // 27000k=3250k
      { value: 30000, bonus: 3600 }  // 30000k=3600k
    ]
  };

  const coinOptionMobile = {
    firstRow: [
      { value: 100, bonus: 0 },
      { value: 250, bonus: 0 },
      { value: 500, bonus: 25 }  // 500k=25k
    ],
    secondRow: [
      { value: 600, bonus: 30 },  // 600k=30k
      { value: 800, bonus: 40 },   // 800k=40k
      { value: 1000, bonus: 50 }   // 1000k=50k
    ],
    thirdRow: [
      { value: 1500, bonus: 85 },  // 1500k=85k
      { value: 2000, bonus: 120 },  // 2000k=120k
      { value: 2500, bonus: 160 }   // 2500k=160k
    ],
    fourthRow: [
      { value: 3000, bonus: 210 },  // 3000k=210k
      { value: 3500, bonus: 270 },   // 3500k=270k
      { value: 4000, bonus: 330 }    // 4000k=330k
    ],
    fifthRow: [
      { value: 4500, bonus: 380 },  // 4500k=380k
      { value: 5000, bonus: 450 },  // 5000k=450k
      { value: 6000, bonus: 550 }   // 6000k=550k
    ],
    SixRow: [
      { value: 7000, bonus: 700 },   // 7000k=700k
      { value: 8000, bonus: 820 },   // 8000k=820k
      { value: 10000, bonus: 1040 }  // 10000k=1040k
    ],
    SevenRow: [
      { value: 12000, bonus: 1280 }, // 12000k=1280k
      { value: 15000, bonus: 1600 }, // 15000k=1600k
      { value: 20000, bonus: 2300 }  // 20000k=2300k
    ],
    eighthRow: [
      { value: 25000, bonus: 3000 }, // 25000k=3000k
      { value: 27000, bonus: 3250 }, // 27000k=3250k
      { value: 30000, bonus: 3600 }  // 30000k=3600k
    ]
  };
  const handleQuantityChange = (value) => {
    const quantityInK = Math.max(100, Math.min(30000, value)); // Restrict between 100 and 30000
    setQuantity(quantityInK);

    // Combine all options from desktop and mobile to find the selected quantity
    const allDesktopOptions = [
      ...coinOptions.firstRow,
      ...coinOptions.secondRow,
      ...coinOptions.thirdRow,
      ...coinOptions.fourthRow,
      ...coinOptions.fifthRow,
      ...coinOptions.sixthRow || []
    ];

    const allMobileOptions = [
      ...coinOptionMobile.firstRow,
      ...coinOptionMobile.secondRow,
      ...coinOptionMobile.thirdRow,
      ...coinOptionMobile.fourthRow,
      ...coinOptionMobile.fifthRow,
      ...coinOptionMobile.SixRow || [],
      ...coinOptionMobile.SevenRow || [],
      ...coinOptionMobile.eighthRow || []
    ];

    const allOptions = [...allDesktopOptions, ...allMobileOptions];

    // Find the matching option to get the predefined bonus
    const matchingOption = allOptions.find(opt => opt.value === quantityInK);
    setSelectedOption(matchingOption ? quantityInK : null);

    // Set bonus from the matching option (0 if not found)
    const bonus = matchingOption ? matchingOption.bonus : 0;
    setSelectedBonus(bonus);

    const calculatedAmount = (quantityInK * prices.XB) / 100;
    setAmount(calculatedAmount);
    setCashback(calculatedAmount * cashbackRate);
  };

  // Handle checkout button
  const handleCheckout = () => {
    if (!token && !guestCheckout) {
      // Show GuestPop if not logged in
      setShowGuestPop(true);
    } else {
      // Proceed to checkout (can redirect to another page or process payment)
      setShowCheckout(true);
    }
  };




  // Continue as guest button functionality
  const handleContinueAsGuest = () => {
    setGuestCheckout(true); // Enable guest checkout
    setShowGuestPop(false); // Close the GuestPop
    setShowCheckout(true); // Proceed to checkout

    console.log("Continuing as guest...");
    // Additional logic for guest checkout can go here
  };


  if (showCheckout) {
    return (
      <XboxCheckout
        quantity={quantity}
        amount={amount}
        cashback={cashback}
        currency={currency} // Pass currency to XboxCheckout
        gatewayFees={amount * gatewayFees + 0.3}
        selectedBonus={selectedBonus}
      />
    );
  }

  return (
    <>
      <div className="lg:bg-bg-[#191919]  bg-[#191919]">

        {showGuestPop && (
          <GuestPop
            onGuestCheckout={handleContinueAsGuest} // Pass guest checkout handler
          />
        )}

        <section className="lg:bg-bg-[#191919]  bg-[#191919]  text-white min-h-screen px-2 sm:px-6 lg:px-8 lg:block hidden">
          {/* Header Section */}
          <div className="flex flex-row justify-center items-center mb-8">
            <img src={xbLogo} alt="Xbox Logo" className="w-10 mr-4" />
            <h1 className="text-3xl lg:text-4xl font-bold">Xbox Coins</h1>
          </div>




          {/* Main Card */}
          <div className="bg-[#191919] border border-xb rounded-3xl p-8 max-w-3xl mx-auto">
            {/* Fast Coins Title */}

            <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
              {coinOptions.firstRow.map((option) => (
                <div
                  key={option.value}
                  className="relative cursor-pointer w-[120px]"
                  onClick={() => handleQuantityChange(option.value)}
                >
                  <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                    ? 'bg-xb border-xb text-black'
                    : 'bg-[#191919] border-xb text-xb'
                    }`}>
                    <img src={coinIcon} alt="Coin" className="w-5 ml-2 h-5 mr-2" />
                    <span className="font-bold text-[16px] leading-none tracking-tight">
                      {option.value}K
                    </span>
                  </div>
                  {option.bonus > 0 && (
                    <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                      +{option.bonus}K <span className="italic">Coins</span>
                    </div>
                  )}
                </div>
              ))}
            </div>


            <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
              {coinOptions.secondRow.map((option) => (
                <div
                  key={option.value}
                  className="relative cursor-pointer w-[120px]"
                  onClick={() => handleQuantityChange(option.value)}
                >
                  <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                    ? 'bg-xb border-xb text-black'
                    : 'bg-[#191919] border-xb text-xb'
                    }`}>
                    <img src={coinIcon} alt="Coin" className="w-5 h-5 ml-2 mr-2" />
                    <span className="font-bold text-[16px] leading-none tracking-tight">
                      {option.value}K
                    </span>
                  </div>
                  <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                    +{option.bonus}K <span className="italic">Coins</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
              {coinOptions.thirdRow.map((option) => (
                <div
                  key={option.value}
                  className="relative cursor-pointer w-[120px]"
                  onClick={() => handleQuantityChange(option.value)}
                >
                  <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                    ? 'bg-xb border-xb text-black'
                    : 'bg-[#191919] border-xb text-xb'
                    }`}>
                    <img src={coinIcon} alt="Coin" className="w-5  ml-2 h-5 mr-2" />
                    <span className="font-bold text-[16px] leading-none tracking-tight">
                      {option.value}K
                    </span>
                  </div>
                  <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                    +{option.bonus}K <span className="italic">Coins</span>
                  </div>
                </div>
              ))}
            </div>







            {showHigherTiersPC && (
              <>
                <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
                  {coinOptions.fourthRow.map((option) => (
                    <div
                      key={option.value}
                      className="relative cursor-pointer w-[120px]"
                      onClick={() => handleQuantityChange(option.value)}
                    >
                      <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                        ? 'bg-xb border-xb text-black'
                        : 'bg-[#191919] border-xb text-xb'
                        }`}>
                        <img src={coinIcon} alt="Coin" className="w-5  h-5 mr-2" />
                        <span className="font-bold text-[16px] leading-none tracking-tight">
                          {option.value}K
                        </span>
                      </div>
                      <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)]">
                        +{option.bonus}K <span className="italic">Coins</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
                  {coinOptions.fifthRow.map((option) => (
                    <div
                      key={option.value}
                      className="relative cursor-pointer w-[120px]"
                      onClick={() => handleQuantityChange(option.value)}
                    >
                      <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                        ? 'bg-xb border-xb text-black'
                        : 'bg-[#191919] border-xb text-xb'
                        }`}>
                        <img src={coinIcon} alt="Coin" className="w-5  h-5 mr-2" />
                        <span className="font-bold text-[16px] leading-none tracking-tight">
                          {option.value}K
                        </span>
                      </div>
                      <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                        +{option.bonus}K <span className="italic">Coins</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-4 gap-4 mb-8 ml-6">
                  {coinOptions.sixthRow.map((option) => (
                    <div
                      key={option.value}
                      className="relative cursor-pointer w-[120px]"
                      onClick={() => handleQuantityChange(option.value)}
                    >
                      <div className={`border rounded-xl py-3 px-3 flex items-center ${selectedOption === option.value
                        ? 'bg-xb border-xb text-black'
                        : 'bg-[#191919] border-xb text-xb'
                        }`}>
                        <img src={coinIcon} alt="Coin" className="w-5  h-5 mr-2" />
                        <span className="font-bold text-[16px] leading-none tracking-tight">
                          {option.value}K
                        </span>
                      </div>
                      <div className="absolute -top-4 right-0 bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[10px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                        +{option.bonus}K <span className="italic">Coins</span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}


            {/* Enter Manually Button */}
            {/* <div className="mb-6 flex justify-center mt-6">
<button
className="bg-primary text-black text-sm font-bold rounded-lg py-1.5 px-6"
onClick={() => setManualInputMode(true)}
>
Enter Manually
</button>
</div> */}
            {/* Quantity Input with +/- buttons */}
            <div className="flex justify-center gap-8 mb-8 font-inter mt-10">
              {/* Amount Section */}
              <div className="flex flex-col items-center relative">
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                  <img src={img2 || "/placeholder.svg"} alt="Money Bag" className="w-9 h-9" />
                </div>
                <div className="flex items-center mb-2 mt-4">
                  <span className="text-white font-normal">Amount</span>
                </div>
                <div className="bg-xb text-black text-[14px] font-bold font-inter py-2 px-6 rounded-lg min-w-[109px] text-center whitespace-nowrap">
                  {`${amount.toFixed(2)} ${currencySymbol}`}
                </div>
              </div>

              {/* Quantity Section */}
              <div className="flex flex-col items-center relative">
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                  {/* Add your quantity icon here - you can use a coin stack icon */}
                  <div className="w-9 h-9  rounded-full flex items-center justify-center">
                    <img src={img1 || "/placeholder.svg"} alt="Cashback" className="w-9 h-9" />                  </div>
                </div>
                <div className="flex items-center mb-2 mt-4">
                  <span className="text-white font-normal">Quantity</span>
                </div>
                <div className="relative">
                  <div className="bg-xb text-black text-[14px] font-bold font-inter py-2 px-6 rounded-lg min-w-[109px] text-center whitespace-nowrap">
                    {quantity}K
                  </div>
                  {selectedBonus > 0 && (
                    <div className="absolute -bottom-4 right-[18px] bg-gradient-to-b from-[#FFE55A] to-[#FFD700] text-black text-[8px] font-bold rounded-full py-1 px-2 shadow-[0_4px_10px_rgba(0,0,0,0.2)] before:content-[''] before:absolute before:inset-x-0 before:top-0 before:h-1/3 before:bg-gradient-to-b before:from-white before:to-transparent before:opacity-40 before:rounded-t-full overflow-hidden">
                      +{selectedBonus >= 1000 ? `${selectedBonus / 1000}K` : selectedBonus}K <span className="italic">Coins</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Cashback Section */}
              <div className="flex flex-col items-center relative">
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                  <img src={img3 || "/placeholder.svg"} alt="Cashback" className="w-9 h-9" />
                </div>
                <div className="flex items-center mb-2 mt-4">
                  <span className="text-white font-normal">Cashback</span>
                </div>
                <div className="bg-xb text-black text-[14px] font-bold font-inter py-2 px-6 rounded-lg min-w-[109px] text-center whitespace-nowrap">
                  {`${cashback.toFixed(2)} ${currencySymbol}`}
                </div>
              </div>
            </div>

            {/* Buy Now button */}
            <div className="flex items-center justify-between mb-4 ml-6">
              <div className="text-xb font-bold flex items-center">
                <img src={EnergyTime} alt="Energy Time" className="w-2 h-3 mr-1" />
                20 Mins
              </div>
              <button
                className={`font-bold w-[36%] py-3 rounded-md transition border-2 ${selectedOption === 0
                  ? "border-xb text-xb  bg-transparent opacity-50 cursor-not-allowed"
                  : "border-xb text-xb bg-[#191919] hover:bg-xb hover:text-black active:bg-xb-dark active:scale-95"
                  }`}
                onClick={selectedOption === 0 ? undefined : handleCheckout}
                disabled={selectedOption === 0}
              >
                Checkout
              </button>
              <div className="text-xb font-bold flex items-center mr-12">
                <img src={clock} alt="Clock Icon" className="w-4 h-4 mr-1" />
                24/7
              </div>
            </div>

            {/* How to buy link */}
            <div id="how-to-buy" className="flex justify-center">
              <a
                href="#how-to-buy"
                className="text-xb w-[35%] font-inter font-bold text-sm flex items-center border border-xb rounded-md py-2 px-6"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('how-to-buy')?.scrollIntoView({
                    behavior: 'smooth'
                  });
                }}
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd"></path>
                </svg>
                <p className="underline">How to buy FC25 coins?</p>
              </a>
            </div>


          </div>


          <div className="hidden md:flex mt-6 bg-xb max-w-3xl mx-auto rounded-lg p-4 text-black font-inter items-center justify-center">
            <p className="font-bold text-[12px] text-center">
              Requirements to order: <span className="font-normal">Unlocked web/companion app transfer market, 1500 coins, and less than 5 unassigned items.</span>
            </p>
          </div>


          <div className="bg-[#191919] mt-6 border border-primary rounded-3xl p-8 max-w-3xl mx-auto">
            <div className="flex flex-col items-center">
              <strong
                style={{
                  fontWeight: 600,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
                className="text-3xl bg-primary sm:text-4xl font-monument lg:text-5xl font-bold text-center"
              >
                HOW TO BUY<br />
                FC25 COINS ON<br />
                FUTCOINSPOT?
              </strong>

              <div className="mt-4">
                <img
                  src={downArrow}
                  alt="Arrow Down"
                  className="h-7 mb-2"

                />
              </div>
            </div>


            <div className="mt-8 text-primary space-y-6 font-inter text-[13px] leading-relaxed">
              <div>
                <button className="relative overflow-hidden group">
                  <div
                    className="
relative z-10 px-6 py-3 text-black font-bold text-lg font-inter rounded-md
bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
border-2 border-[#FFFA00]
shadow-inner shadow-yellow-300
hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
transition-shadow duration-300
active:translate-y-[1px] active:shadow-none
"
                    style={{
                      filter:
                        "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                    }}
                  >
                    1. NECESSARY INFORMATION
                  </div>
                </button>

                <ul className="list-disc list-inside mt-6 text-[18px] marker:text-primary marker:text-2xl">
                  <li>EA FC 25 Web App Email</li>
                  <li>EA FC 25 Web App Password</li>
                  <li>1 Backup Code</li>
                </ul>

              </div>

              <div>



                <button className="relative overflow-hidden group">
                  <div
                    className="
relative z-10 px-6 py-3 text-black font-bold text-lg font-inter rounded-md
bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
border-2 border-[#FFFA00]
shadow-inner shadow-yellow-300
hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
transition-shadow duration-300
active:translate-y-[1px] active:shadow-none
"
                    style={{
                      filter:
                        "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                    }}
                  >
                    2. THINGS TO KNOW BEFORE PURCHASE ON FUTCOINSPOT
                  </div>
                </button>


                <ol className="mt-6 text-lg space-y-4">
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">①</span>
                    <span><span className="font-bold">Transfer Market:</span> Before moving forward, make sure that the transfer market is available on your FUT Web or the App.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">②</span>
                    <span><span className="font-bold">Coin Requirement:</span> You need a minimum of 1,500 EA FC coins in your game account to start funding. Having more coins will lead to faster and safer order fulfillment.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">③</span>
                    <span><span className="font-bold">Stay Logged Out:</span> During the transaction, do not log into your FC 25 game account, Web App, or Mobile App to prevent any interruptions in the coin delivery process.</span>
                  </li>
                </ol>
              </div>

              <div>




                <button className="relative overflow-hidden group">
                  <div
                    className=" mb-4 font-inter text-lg
relative z-10 px-6 py-3 text-black font-bold rounded-md
bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
border-2 border-[#FFFA00]
shadow-inner shadow-yellow-300
hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
transition-shadow duration-300
active:translate-y-[1px] active:shadow-none
"
                    style={{
                      filter:
                        "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                    }}
                  >
                    3. EA FC COINS PURCHASE PROCESS ON FUTCOINSPOT
                  </div>
                </button>
                <ol className="mt-2 text-lg space-y-4 font-[600px]">
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">①</span>
                    <span>Make sure you've unlocked the transfer market and have more than 3000 FUT coins. How to get Transfer Market access? <a href="https://help.ea.com/uk/help/ea-sports-fc/transfer-market-web-and-companion-apps/?fbclid=IwZXh0bgNhZW0CMTEAAR6QNZUXqPA2yYJooPpIJ9eeRo9T-VR7qoahC4DbYVFUW8ro5QNd19w3BdOw1w_aem_7Ak0ZSl3UxJy5rJ_vm9KEA" className="underline text-primary">Click Here</a></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">②</span>
                    <span className="mt-1">Choose your platform and the amount of coins.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">③</span>
                    <span className="mt-1">Fill in your EA account details, including email, password, and backup codes.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">④</span>
                    <span className="mt-1">Keep logged out of your platform and Web App until the delivery is completed.</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-lg font-bold text-primary">⑤</span>
                    <span className="mt-1">When Order Status shows "Completed", the transaction is completed. You will be notified via email once your order is fulfilled and you can also track your order <a href="https://www.futcoinspot.com/track-order" className="underline text-primary">here</a>.</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>


        </section>



        <section className="lg:hidden bg-[#191919] text-white border border-xb rounded-3xl py-8 px-4 mx-4">
          {/* Header Section */}
          <div className="flex flex-col items-center mb-6">
            <img src={xbLogo} alt="Xbox Logo" className="w-16 mb-4" />
            <h1 className="text-2xl font-bold text-center">Xbox Coins</h1>
          </div>

          {/* Fast Coins Title */}


          {/* First 3 Rows (100K - 5000K) */}
          <div className="grid grid-cols-3 gap-4 mb-6">
            {coinOptionMobile.firstRow.map((option) => (
              <CoinOption
                key={option.value}
                option={option}
                selectedOption={selectedOption}
                handleQuantityChange={handleQuantityChange}
              />
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            {coinOptionMobile.secondRow.map((option) => (
              <CoinOption
                key={option.value}
                option={option}
                selectedOption={selectedOption}
                handleQuantityChange={handleQuantityChange}
              />
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            {coinOptionMobile.thirdRow.map((option) => (
              <CoinOption
                key={option.value}
                option={option}
                selectedOption={selectedOption}
                handleQuantityChange={handleQuantityChange}
              />
            ))}
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            {coinOptionMobile.fourthRow.map((option) => (
              <CoinOption
                key={option.value}
                option={option}
                selectedOption={selectedOption}
                handleQuantityChange={handleQuantityChange}
              />
            ))}
          </div>

          {/* Discover More Button */}

          {/* Higher Tiers (when shown) */}
          {showHigherTiers && (
            <>
              {/* Fourth Row (6000K - 12000K) */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                {coinOptionMobile.fifthRow.map((option) => (
                  <CoinOption
                    key={option.value}
                    option={option}
                    selectedOption={selectedOption}
                    handleQuantityChange={handleQuantityChange}
                  />
                ))}
              </div>

              {/* Fifth Row (15000K - 30000K) */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                {coinOptionMobile.SixRow.map((option) => (
                  <CoinOption
                    key={option.value}
                    option={option}
                    selectedOption={selectedOption}
                    handleQuantityChange={handleQuantityChange}
                  />
                ))}
              </div>
              <div className="grid grid-cols-3 gap-4 mb-6">
                {coinOptionMobile.SevenRow.map((option) => (
                  <CoinOption
                    key={option.value}
                    option={option}
                    selectedOption={selectedOption}
                    handleQuantityChange={handleQuantityChange}
                  />
                ))}
              </div>
              <div className="grid grid-cols-3 gap-4 mb-6">
                {coinOptionMobile.eighthRow.map((option) => (
                  <CoinOption
                    key={option.value}
                    option={option}
                    selectedOption={selectedOption}
                    handleQuantityChange={handleQuantityChange}
                  />
                ))}
              </div>
            </>
          )}

          <div className="mb-6">
            <button
              className={`w-full font-bold rounded-lg py-2 px-6 hover:bg-opacity-80 transition flex items-center justify-center ${showHigherTiers
                ? 'bg-xb text-black'
                : 'bg-[#191919] text-xb border-xb border-2'
                }`}
              onClick={() => setShowHigherTiers(!showHigherTiers)}
            >
              {showHigherTiers ? 'See Less' : 'Discover More'}
              <img
                src={showHigherTiers ? Carrot : Carrot2}
                alt={showHigherTiers ? "See Less Icon" : "Discover More Icon"}
                className="w-3 h-2 ml-2"
              />
            </button>
          </div>

          {/* Enter Manually Button */}


          {/* <div className="mb-3 flex justify-center"> 
             <button
               className="bg-primary text-black text-sm font-bold rounded-lg py-1.5 px-6"
               onClick={() => setManualInputMode(true)}
             >
               Enter Manually
             </button>
           </div> */}

          <div className="flex flex-col">
            {/* Quantity Input (Assuming exists here) */}

            <div className="flex items-center justify-between px-4 mt-3">
              {/* Left timing info */}
              <div className="text-xb text-sm font-bold flex items-center gap-1 whitespace-nowrap min-w-[80px]">
                <img src={EnergyTime} alt="Energy Time" className="w-2 h-3 mr-1" />
                20 Mins
              </div>

              {/* Column container for Buy Now and How to Buy */}
              <div className="flex flex-col flex-1 mx-4">
                <button
                  className={`font-bold py-3 px-4 rounded-md transition border-2 w-full ${selectedOption === 0
                    ? "border-xb text-xb bg-transparent opacity-50 cursor-not-allowed"
                    : "border-xb text-xb bg-[#191919] hover:bg-xb hover:text-black active:bg-xb-dark active:scale-95"
                    }`}
                  onClick={selectedOption === 0 ? undefined : handleCheckout}
                  disabled={selectedOption === 0}
                >
                  Checkout
                </button>
                {/* This button aligned right below Buy Now, full width */}
                <a
                  href="#how-to-buy-mobile"
                  className="text-xb font-bold text-sm flex items-center justify-center border border-xb rounded-md py-2 mt-3 w-full"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('how-to-buy-mobile')?.scrollIntoView({
                      behavior: 'smooth',
                    });
                  }}
                >
                  <svg
                    className="w-2 h-2 mr-1 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="underline text-[8px]">How to buy FC25 Coins ?</span>
                </a>
              </div>

              {/* Right timing info */}
              <div className="text-xb text-sm font-bold flex items-center gap-1 whitespace-nowrap min-w-[60px] justify-end">
                <img src={clock} alt="Clock Icon" className="w-4 h-4" />
                24/7
              </div>
            </div>
          </div>


          {/* Requirements */}

          {selectedOption > 0 && (
            <div className="fixed bottom-11 rounded-t-2xl left-0 right-0 bg-xb p-6 z-50">
              <div className="container mx-auto">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-black text-sm">Amount</span>
                  <span className="text-black text-sm">  {`${amount.toFixed(2)} ${currencySymbol}`}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-black text-sm">Cashback</span>
                  <span className="text-black text-sm">  {`${cashback.toFixed(2)} ${currencySymbol}`}</span>
                </div>
              </div>
            </div>
          )}



        </section>

        <div
          id="how-to-buy-mobile"
          className="bg-[#191919] mt-6 border ml-3 mr-3 border-primary rounded-3xl p-8 max-w-3xl mx-auto lg:hidden"
        >          <div className="flex flex-col items-center">
            <strong
              style={{
                fontWeight: 600,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent"
              }}
              className="text-2xl bg-primary  font-monument font-bold text-center"
            >
              HOW TO BUY<br />
              FC25 COINS ON<br />
              FUTCOINSPOT?
            </strong>

            <div className="mt-4">
              <img
                src={downArrow}
                alt="Arrow Down"
                className="h-5 mb-2"

              />
            </div>
          </div>


          <div className="mt-8 text-primary space-y-6 font-inter text-[13px] leading-relaxed">
            <div>

              <button className="relative overflow-hidden group">
                <div
                  className="
        relative z-10 px-3 py-3 text-[10px] text-black w-[100%] font-bold text-left font-inter rounded-md
        bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
        border-2 border-[#FFFA00]
        shadow-inner shadow-yellow-300
        hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
        transition-shadow duration-300
        active:translate-y-[1px] active:shadow-none
      "
                  style={{
                    filter: "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                  }}
                >
                  1. NECESSARY INFORMATION
                </div>
              </button>


              <ul className="list-disc list-inside mt-6 text-[11px] marker:text-primary marker:text-[11px]">
                <li className="flex items-start gap-1">
                  <span className="text-primary text-[18px] mr-1">•</span>
                  <span className="mt-2">EA FC 25 Web App Email</span>
                </li>

                <li className="flex items-start gap-1">
                  <span className="text-primary text-[18px] mr-1">•</span>
                  <span className="mt-2">EA FC 25 Web App Password</span>
                </li>

                <li className="flex items-start gap-1">
                  <span className="text-primary text-[18px] mr-1">•</span>
                  <span className="mt-2">1 Backup Code</span>
                </li>

              </ul>

            </div>

            <div>


              <button className="relative overflow-hidden group ">
                <div
                  className="
       relative z-10 px-3 py-3 text-[10px] text-black w-[60%] font-bold text-left font-inter rounded-md
       bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
       border-2 border-[#FFFA00]
       shadow-inner shadow-yellow-300
       hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
       transition-shadow duration-300
       active:translate-y-[1px] active:shadow-none
     "
                  style={{
                    filter:
                      "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                  }}
                >
                  2. THINGS TO KNOW BEFORE PURCHASE ON FUTCOINSPOT
                </div>
              </button>

              <ol className=" text-[11px] space-y-4 mt-8 font-inter">
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">①</span>
                  <span><span className="font-bold">Transfer Market:</span> Before moving forward, make sure that the transfer market is available on your FUT Web or the App.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">②</span>
                  <span><span className="font-bold">Coin Requirement:</span> You need a minimum of 1,500 EA FC coins in your game account to start funding. Having more coins will lead to faster and safer order fulfillment.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">③</span>
                  <span> <span className="font-bold">Stay Logged Out:</span> During the transaction, do not log into your FC 25 game account, Web App, or Mobile App to prevent any interruptions in the coin delivery process.</span>
                </li>
              </ol>
            </div>

            <div>



              <button className="relative overflow-hidden group mt-4">
                <div
                  className="
       relative z-10 px-3 py-3 text-[10px] text-black w-[63%] font-bold text-left font-inter rounded-md
       bg-gradient-to-r from-[#FFFFFF] to-[#FFFA00]
       border-2 border-[#FFFA00]
       shadow-inner shadow-yellow-300
       hover:shadow-[inset_0_4px_6px_rgba(210,190,0,0.6),0_2px_0_0_rgba(210,190,0,0.9)]
       transition-shadow duration-300
       active:translate-y-[1px] active:shadow-none
     "
                  style={{
                    filter:
                      "drop-shadow(0 2px 2px rgba(210, 190, 0, 0.5))",
                  }}
                >
                  3. EA FC COINS PURCHASE PROCESS ON FUTCOINSPOT
                </div>
              </button>




              <ol className="text-[11px] space-y-4 mt-8 font-inter">
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">①</span>
                  <span>Make sure you've unlocked the transfer market and have more than 3000 FUT coins. How to get Transfer Market access? <a href="https://help.ea.com/uk/help/ea-sports-fc/transfer-market-web-and-companion-apps/?fbclid=IwZXh0bgNhZW0CMTEAAR6QNZUXqPA2yYJooPpIJ9eeRo9T-VR7qoahC4DbYVFUW8ro5QNd19w3BdOw1w_aem_7Ak0ZSl3UxJy5rJ_vm9KEA" className="underline text-primary">Click Here</a></span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">②</span>
                  <span>Choose your platform and the amount of coins.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">③</span>
                  <span>Fill in your EA account details, including email, password, and backup codes.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">④</span>
                  <span>Keep logged out of your platform and Web App until the delivery is completed.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[12px] font-bold text-primary">⑤</span>
                  <span>When Order Status shows "Completed", the transaction is completed. You will be notified via email once your order is fulfilled and you can also track your order <a href="https://www.futcoinspot.com/track-order" className="underline text-primary">here</a>.</span>
                </li>
              </ol>
            </div>
          </div>
        </div>

      </div>

    </>
  );
};

export default XboxCoins;
